import { Component, Injectable } from '@angular/core';
import { CodeSnippet } from '../code-snippets/code-snippet.interface';



@Component({
    selector: 'call northbound API',
    template: '',
    standalone: false
})
export class NorthboundApiExampleDPHistory implements CodeSnippet{

    text : string = $localize`:@@script-editor.code-example.call-northbound-api:Northbound API (DP History)`;

    category: string = 'examples';

    data: any;

    part = false;

    insert(): string | Promise<string> {
        return `function main()

    -- initialize multiplier for one days milliseconds
    local oneDaysMS = 86400 * 1000

    -- get current unixtimestamp (in milliseconds) as enddate
    local tsUntil = now()

    -- subtract 10 days to get start date
    local tsFrom = tsUntil - 10 * oneDaysMS

    -- output dates in plain text
    show("\\r\\nFROM: {0}\\r\\nTO..: {1}", date(tsFrom), date(tsUntil))

    -- get plant object
    local plant = getplant()

    -- call the NB API
    local hist = api("GET /DataPoints/"..plant.PlantId..";1!vLuaPointInt/History?maxNumberOfPoints=5&includePredecessor=true&start="..tsFrom.."&end="..tsUntil)
  
    -- get the subentity
    local values = hist.values.values[plant.PlantId..';1!vLuaPointInt']

    -- iterate and output the result values
    for _, v in ipairs(values) do

        -- output the values
        show("{0} {1}", v.seq, date(v.date))

    end

end
`
    }
}